module.exports = __webpack_public_path__ + "img/model_49_zh.1c2306ce.jpg";